// Keeps a checkout button's enabled state and label in sync with its live payment widget.
// Queries state by checkout reference; the Stripe checkout component handles the actual submission.
import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { CHECKOUT_STATE_EVENT, CHECKOUT_STATE_REQUEST_EVENT } from '../../stripe_checkout/events'

registerFunctionalComponent('.js-c-payments-checkout-submit', 'CheckoutSubmit', initCheckoutSubmit)

function initCheckoutSubmit(component) {
  const button = component.element
  const label = button.querySelector('.js-c-payments-checkout-submit-text')
  const text = label.textContent
  const checkoutReference = button.dataset.checkoutReference

  function update({ ready = false, submitting = false } = {}) {
    button.disabled = !ready || submitting
    button.setAttribute('aria-busy', String(submitting))
    label.textContent = submitting ? 'Processing...' : text
  }

  // A state event is only a notification. Ask the mounted provider for a fresh snapshot,
  // resetting to disabled first so removed providers and late-mounted buttons cannot leave stale readiness.
  function requestState() {
    update()
    document.dispatchEvent(new CustomEvent(CHECKOUT_STATE_REQUEST_EVENT, {
      detail: { checkoutReference, respond: update },
    }))
  }

  component.useHandler(() => on(CHECKOUT_STATE_EVENT, document, event => {
    if (event.detail.checkoutReference === checkoutReference) requestState()
  }))
  component.useHandler(() => () => update())
  requestState()
}
